import React from 'react';
import { Nav, Row, Col, Button, Spinner } from 'react-bootstrap';
import utils from '../../../utils';
import { useLocation } from 'react-router-dom';
import DynamicIcon from '../../DynamicIcon';
import { LinkContainer } from 'react-router-bootstrap';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';
import { Gear } from 'react-bootstrap-icons';

function TenantAppAccordian({ tenant, tenantSlug = '', tenantApps, sa = false, show, raiseSupport, showNavHandler, screenSize, onLinkClick, showFakes = false }) {

  let { pathname } = useLocation();

  const { user } = useAuth0();
  const accounts = user ? [user] : [];

  const getRouteName = (name) => {
    if (name === '/' || name === '/news' || name === '/intelligence') {
      onLinkClick(name)
    }
  }

  const getAppPath = (app) => {
    if (app.fields.apptype === 'dynamic' && app.fields.customctalink) {
      return `/apps/${app.fields.customctalink}`;
    }
    return `/${app.fields.customctalink || app.fields.apptype}`;
  };

  const appIsActive = (pth, apptype) => {
    //first blow pth apart
    let pthArray = pth.split('/');

    //the app should be only in the first or second item
    if (pthArray.length > 0) {
      return pthArray[0].toLowerCase() === apptype.trim().toLowerCase() || pthArray[1].toLowerCase() === apptype.trim().toLowerCase();
    }

    return false;

  }

  const isHome = pathname === '/';


  return (
    tenantApps ?
      //for lg and > viewports
      screenSize === 'large' ?
        <>
          <Nav className="flex-column"
            onMouseEnter={() => showNavHandler(true)}
            onMouseLeave={() => showNavHandler(false)}
          >
            <Col>
              <Row className="app-link-list">

                <LinkContainer
                  to="/"
                  isActive={(match, location) => location.pathname === '/'}
                  className={`${isHome ? 'active-tenant' : ''} home-link sidenav-link`}
                  onClick={() => getRouteName(pathname)}
                  end
                >
                  <Row className={show ? 'showName' : 'hideName'}>
                    <div className={`icon-wrapper ${show ? 'expanded' : 'collapsed'}`}>
                      <DynamicIcon className="sideNavOption svg-16" iconName="House" />
                    </div>
                    <Col md={10} className="hideAppName">Home</Col>
                  </Row>
                </LinkContainer>

                {showFakes === false && tenantApps.map((tenant, index) => (
                  <LinkContainer
                    key={index}
                    to={getAppPath(tenant)}
                    onClick={getRouteName(pathname)}
                    className={appIsActive(pathname, tenant.fields.apptype) ? 'active-tenant sidenav-link' : 'sidenav-link'}
                  >
                    <Row>
                      <div className={`icon-wrapper ${show ? 'expanded p-i-end-03' : 'collapsed'}`}>
                        {tenant.fields.iconname && (
                          <DynamicIcon className="sideNavOption svg-16" iconName={tenant.fields.iconname} />
                        )}
                      </div>
                      <Col md={10} className='hideAppName p-i-start-0 p-i-end-03'>
                        {tenant.fields.appAlternateTitle ? tenant.fields.appAlternateTitle : utils.getAppName(tenant.fields.apptype)}
                      </Col>
                    </Row>
                  </LinkContainer>
                ))}

                {sa && tenantSlug.toLowerCase() === 'lb-level-q' && (
                  <LinkContainer
                    to='/super_admin'
                    className={pathname.includes('super_admin') ? 'active-tenant sidenav-link' : 'sidenav-link'}
                  >
                    <Row>
                      <div className={`icon-wrapper ${show ? 'expanded' : 'collapsed'}`}>
                        <DynamicIcon className='sideNavOption svg-16' iconName="Star" />
                      </div>
                      <Col md={10} className='hideAppName'>Super Admin</Col>
                    </Row>
                  </LinkContainer>
                )}
              </Row>
            </Col>
          </Nav>
        </>
        :
        // For med, sm, xs viewports
        <Nav className="flex-column">
          <Row>
            <Col xs={2} sm={4} md={4}></Col>
            <Col xs={8} sm={5} md={5} className='nav-content'>
              <Row className='app-list'>
                <Row className='app-link-list'>
                  <LinkContainer
                    to={'/'}
                    className={pathname === '/' ? 'active-tenant home-link sidenav-link' : 'home-link sidenav-link'}
                  >
                    <Row className={show && show === true ? 'showName' : 'hideName'}>
                      <Col xs={4} sm={3} md={2} className='home-icon-col'>
                        <DynamicIcon className='sideNavOption  svg-16' iconName={'House'} />
                      </Col>
                      <Col xs={8} sm={9} md={10} className='hideAppName'>
                        Home
                      </Col>
                    </Row>
                  </LinkContainer>
                  {
                    tenantApps.map((tenant, index) => {
                      return (
                        <LinkContainer
                          key={index}
                          to={getAppPath(tenant)}
                          className={pathname.includes(tenant.fields.apptype.toLowerCase()) ? "active-tenant sidenav-link" : 'sidenav-link'}
                        >
                          <Row>
                            <Col xs={4} sm={3} md={2} className='app-icon-col'>
                              {
                                tenant.fields.iconname ?
                                  <DynamicIcon className='sideNavOption  svg-16' iconName={tenant.fields.iconname} />
                                  : ''
                              }
                            </Col>
                            <Col xs={8} sm={9} md={10} className='hideAppName'>
                              {tenant.fields.appAlternateTitle ? tenant.fields.appAlternateTitle : utils.getAppName(tenant.fields.apptype)}
                            </Col>
                          </Row>
                        </LinkContainer>
                      )
                    })
                  }
                </Row>
                <div className='support-request' onClick={() => { raiseSupport(true) }}>
                  <Row className='support-link'>
                    <Col xs={4} sm={3} md={2} className='support-icon-col'>
                      <DynamicIcon className='sideNavOption svg-16' iconName='ChatQuote' />
                    </Col>
                    <Col xs={8} sm={9} md={10} className='hideAppName'>
                      Feedback
                    </Col>
                  </Row>
                </div>
                {
                  //right now, only settings are for user manager, only show for them
                  accounts && accounts[0] && accounts[0].email && tenant ?
                    utils.isAUserManager(tenant.tenant, accounts[0]) ?
                      <Nav.Link as={Link} to={'/settings'} onClick={() => document.body.click()} className="settings-row-container">
                        <Row className="settings-row">
                          <Col xs={3} sm={2} md={2} className="settings-icon-col">
                            <Gear className="sideNavOption svg-16" />
                          </Col>
                          <Col xs={9} sm={10} md={10} className="settings-label">
                            Settings
                          </Col>
                        </Row>
                      </Nav.Link>
                      : null
                    : null
                }
              </Row>
              {
                show === true ?
                  <div className='close-menu-row'>
                    <DynamicIcon className='close-menu' iconName={'X'} />
                    <Button onClick={showNavHandler}>Close Menu</Button>
                  </div>
                  :
                  <Row className='close-menu-row'>
                    <Col xs={2} sm={4} className='list-icon'>
                      <DynamicIcon className='close-menu' iconName={'List'} />
                    </Col>
                    <Col xs={10} sm={8} className='menu'>
                      <Button onClick={showNavHandler}>Menu</Button>
                    </Col>
                  </Row>
              }
            </Col>
            <Col xs={2} sm={4} md={3}></Col>
          </Row>
        </Nav>
      :
      <Spinner animation='border' />
  )

}

export default TenantAppAccordian;